import { Modal, Spinner } from 'react-bootstrap';
import { useEffect, useState } from "react";

const Loading = ({ loading, msg }) => {
    const [open, setOpen] = useState(false);
    useEffect(() => {
        setOpen(loading);
    }, [loading]);
    return (
        <Modal
            show={open}
            onHide={() => setOpen(false)}
            centered
            backdrop="static"
            keyboard={false}
            size="lg"
        >
            <Modal.Body>
                <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: 150 }}>
                    <Spinner animation="border" style={{ color: '#067CFA', width: '3rem', height: '3rem' }} />
                    {msg && <p className="mt-3 mb-0 fs-5">{msg}</p>}
                </div>
            </Modal.Body>
        </Modal>
    );
}

Loading.defaultProps = {
    msg: "Loading..."
}

export {
    Loading
};